import React, { useState, useEffect, useRef } from 'react';
import { Typography, Box, Paper, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import CampaignsTable from './adminComponents/CampaignKpis';
import CreatorsTable from './adminComponents/CreatorKpis';
import UsersKPI from './adminComponents/UserKpis';
import FinancialsKPI from './adminComponents/FinanceKpis';
import PartnerKpis from './adminComponents/partnerKpis';
import Layout from './layout';
import { StyleStickyButtonContainter, StyleContent, StylePaper } from '../../../../Utils/ThemedStyles';
import KpiCard from './adminComponents/kpiCard';

const classes = {
  filter: {
    minWidth: 120,
  },
};

const Dashboard = () => {
  const [componentFilter, setComponentFilter] = useState("All");
  const [userKpi, setUserKpi] = useState({ progress: 0 });
  const [creatorKpi, setCreatorKpi] = useState({ progress: 0 });
  const [campaignKpi, setCampaignKpi] = useState({ progress: 0 });
  const [partnerKpi, setPartnerKpi] = useState({ progress: 0 });

  // Stagger delay mechanism for KPI loading
  const staggerDelay = useRef(0);

  const getStaggerDelay = () => {
    // Only apply stagger when showing all components
    if (componentFilter !== "All") return 0;

    const delay = staggerDelay.current;
    staggerDelay.current += 200; // 200ms between each component
    return delay;
  };

  // Reset stagger delay when filter changes
  useEffect(() => {
    staggerDelay.current = 0;
  }, [componentFilter]);

  // Weekly goals for each KPI
  const userGoal = 5;
  const creatorGoal = 5;
  const campaignGoal = 20; // Changed to reflect campaigns per week
  const partnerGoal = 5; // Weekly goal for partner signups

  const handleFilterChange = (event) => {
    setComponentFilter(event.target.value);
  };

  return (
    <Box sx={StyleContent}>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <KpiCard title="User Signups" goal={userGoal} progress={userKpi.progress} />
        <KpiCard title="Creator Partners" goal={creatorGoal} progress={creatorKpi.progress} />
        <KpiCard title="Campaigns" goal={campaignGoal} progress={campaignKpi.progress} />
        <KpiCard title="Partner Signups" goal={partnerGoal} progress={partnerKpi.progress} />
      </Box>
      <Box sx={StyleStickyButtonContainter}>
        <FormControl variant="outlined" sx={classes.filter}>
          <InputLabel>Component</InputLabel>
          <Select
            value={componentFilter}
            onChange={handleFilterChange}
            label="Component"
          >
            <MenuItem value="All">
              <em>All</em>
            </MenuItem>
            <MenuItem value="Campaigns">Campaign KPIs</MenuItem>
            <MenuItem value="Users">User KPIs</MenuItem>
            <MenuItem value="Financials">Financial KPIs</MenuItem>
            <MenuItem value="Partners">Partner KPIs</MenuItem>
            <MenuItem value="Creators">General Creator KPIs</MenuItem>
          </Select>
        </FormControl>
      </Box>

      {(componentFilter === "All" || componentFilter === "Campaigns") && (
        <Paper sx={StylePaper}>
          <Typography variant="h6" gutterBottom>
            Campaign KPIs
          </Typography>
          <CampaignsTable setCampaignKpi={setCampaignKpi} delay={getStaggerDelay()} />
        </Paper>
      )}

      {(componentFilter === "All" || componentFilter === "Users") && (
        <Paper sx={StylePaper}>
          <Typography variant="h6" gutterBottom>
            User KPIs
          </Typography>
          <UsersKPI setUserKpi={setUserKpi} delay={getStaggerDelay()} />
        </Paper>
      )}

      {(componentFilter === "All" || componentFilter === "Financials") && (
        <Paper sx={StylePaper}>
          <Typography variant="h6" gutterBottom>
            Financial KPIs
          </Typography>
          <FinancialsKPI delay={getStaggerDelay()} />
        </Paper>
      )}

      {(componentFilter === "All" || componentFilter === "Partners") && (
        <Paper sx={StylePaper}>
          <Typography variant="h6" gutterBottom>
            Partner KPIs
          </Typography>
          <PartnerKpis setPartnerKpi={setPartnerKpi} delay={getStaggerDelay()} />
        </Paper>
      )}

      {(componentFilter === "All" || componentFilter === "Creators") && (
        <Paper sx={StylePaper}>
          <Typography variant="h6" gutterBottom>
            General Creator KPIs
          </Typography>
          <CreatorsTable setCreatorKpi={setCreatorKpi} delay={getStaggerDelay()} />
        </Paper>
      )}
    </Box>
  );
};

export default Dashboard;
